// src/components/ProgressBar/ProgressBar.jsx
//
// Reusable, animated progress indicator for completion percentages.
// Usage: <ProgressBar value={62} label="Completion" />

import React from "react";
import "./ProgressBar.scss";

export default function ProgressBar({
  value = 0,
  label,
  showValue = true,
  tone = "auto",
  size = "md",
}) {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const resolvedTone =
    tone === "auto"
      ? clamped >= 100
        ? "success"
        : clamped >= 50
          ? "info"
          : "warning"
      : tone;

  return (
    <div className={`progress-bar progress-bar--${size}`}>
      {(label || showValue) && (
        <div className="progress-bar__header">
          {label && <span className="progress-bar__label">{label}</span>}
          {showValue && (
            <span className="progress-bar__value">{Math.round(clamped)}%</span>
          )}
        </div>
      )}
      <div
        className="progress-bar__track"
        role="progressbar"
        aria-valuenow={Math.round(clamped)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`progress-bar__fill progress-bar__fill--${resolvedTone}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
